module.exports = "/_next/static/images/Graph_02_conversion@2x-c309feb97b6c68d9d99b2f71671383a8.png";